import { useAuth } from "@/lib/auth";
type StaffRole={id:string;name?:string|null;workspaceId?:string|null};
/** Navigation visibility only; every API separately enforces permissions/scope. */
export function staffTurnoverRole(role:StaffRole|null|undefined,workspaceId:string|undefined){
  if(!role||!workspaceId||(role.workspaceId&&role.workspaceId!==workspaceId))return false;
  if(["branch_manager","location_manager"].includes(role.id))return false;
  if(["admin","system_admin","finance_manager","area_manager"].includes(role.id))return true;
  return role.workspaceId===workspaceId&&["admin","administrator","system admin","owner","finance manager","area manager"].includes(role.name?.trim().toLowerCase()||"");
}
export function useStaffTurnoverAccess(){
  const {user,roles,currentWorkspace}=useAuth();
  return staffTurnoverRole(roles?.find(r=>r.id===user?.roleId),currentWorkspace?.id);
}
